import CustomTabs from "./Tabs";
export default CustomTabs;